/**
 * product-card.js
 * Handles product card interactions: Wishlist (localStorage) and AJAX Add to Cart.
 */
(function () {
  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.wishlistBtn = this.querySelector('.js-wishlist-toggle');
      this.addToCartBtn = this.querySelector('.js-add-to-cart');
      this.errorMsg = this.querySelector('.js-cart-error');
      this.productId = this.dataset.productId;

      if (this.wishlistBtn) {
        this.wishlistBtn.addEventListener('click', this.toggleWishlist.bind(this));
        this.initWishlistState();
      }

      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', this.addToCart.bind(this));
      }
    }

    getWishlist() {
      try {
        return JSON.parse(localStorage.getItem('theme_wishlist')) || [];
      } catch (e) {
        return [];
      }
    }

    saveWishlist(list) {
      try {
        localStorage.setItem('theme_wishlist', JSON.stringify(list));
      } catch (e) {
        console.warn('Unable to save wishlist to localStorage', e);
      }
    }

    initWishlistState() {
      const list = this.getWishlist();
      if (list.includes(this.productId)) {
        this.wishlistBtn.classList.add('is-active');
        this.wishlistBtn.setAttribute('aria-pressed', 'true');
      }
    }

    toggleWishlist() {
      const list = this.getWishlist();
      const index = list.indexOf(this.productId);

      if (index === -1) {
        list.push(this.productId);
        this.wishlistBtn.classList.add('is-active');
        this.wishlistBtn.setAttribute('aria-pressed', 'true');
      } else {
        list.splice(index, 1);
        this.wishlistBtn.classList.remove('is-active');
        this.wishlistBtn.setAttribute('aria-pressed', 'false');
      }
      this.saveWishlist(list);
    }

    async addToCart(e) {
      e.preventDefault();

      if (this.addToCartBtn.disabled || this.addToCartBtn.classList.contains('is-loading')) {
        return;
      }

      const variantId = this.addToCartBtn.dataset.variantId;
      if (!variantId) return;

      // Reset state
      this.addToCartBtn.classList.add('is-loading');
      this.addToCartBtn.setAttribute('aria-busy', 'true');

      if (this.errorMsg) {
        this.errorMsg.classList.remove('is-visible');
        this.errorMsg.textContent = '';
      }

      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Error adding item to cart.');
        }

        // Emit global event for cart drawers/header icons to listen to
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: data },
          bubbles: true
        }));

        // Show success state on the button momentarily
        const originalText = this.addToCartBtn.textContent;
        this.addToCartBtn.textContent = 'Added';

        setTimeout(() => {
          this.addToCartBtn.textContent = originalText;
        }, 2000);

      } catch (error) {
        console.error('Add to Cart Error:', error);

        // Render explicit error in the UI
        if (this.errorMsg) {
          this.errorMsg.textContent = error.message;
          this.errorMsg.classList.add('is-visible');
        }
      } finally {
        this.addToCartBtn.classList.remove('is-loading');
        this.addToCartBtn.setAttribute('aria-busy', 'false');
      }
    }
  }

  // Register the Custom Element
  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
})();
